// src/auth/SessionExpiredModal.jsx
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import DialogWrapper from "./DialogWrapper";
let configx = {
        "title":"",
        "message":"For your security, your session has expired. Please log in again to continue.",
        "buttonLabel":"Re-authenticate",
        "stateHandler":true,
        "onCloseHandler":() => {
            window.location.reload();
        },
        "onClickHandler":() => {
            window.location.reload();
        }
};
let styles= {
    "formContainer": {
        "marginTop": "1rem",
        "marginBottom": "1.5rem"
    },
    "formGrid": {
        "display": "grid",
        "gridTemplateColumns": "1fr",
        "gap": "1",
        "padding": "1",
        "paddingTop": "0",
        "maxWidth": "4xl",
        "margin": "0 auto",
        "backgroundColor": "white",
        "boxShadow": "0 2px 10px rgba(6, 81, 237, 0.3)",
        "borderRadius": "0.375rem",
        "color": "#333",
        "fontFamily": "sans-serif"
    }
}

const SessionModal = ({config=configx}) => {
    return (
        <DialogWrapper
            mode="dialog"
            style={{
                dialog: {
                    fullWidth: true,
                    maxWidth: 'sm',
                    p: 0,
                    m: 0,

                },
                titleBox: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'relative',
                    P: 0
                },
                closeButton: {
                    position: 'absolute',
                    color: (theme) => theme.palette.grey[500],
                    right: -15,
                    top: -10,
                },
                content: {
                    m: 0,
                    p: 0
                },
                inlineContainer: {
                    p: 0,
                    m: 0
                },
            }}
            open={config.stateHandler}
            onClose={config.onCloseHandler}
            title={config.title}
        >
            <div style={styles.formContainer}>
                <div style={styles.formGrid}>
                    <DialogContent sx={{ paddingBottom: 0 }}>
                        {config.message}
                    </DialogContent>
                    <DialogActions sx={{ padding: 2, paddingTop: 1 }}>
                        <Button onClick={config.onClickHandler} color="primary" variant="contained">
                            {config.buttonLabel}
                        </Button>
                    </DialogActions>
                </div></div>
        </DialogWrapper>
    );
};

export default SessionModal;
